module.exports = __webpack_public_path__ + "img/sliders-04.884a7ded.svg";